import React, { useState } from "react";

import Form from "../../../common/forms/Form";
import FormInput from "../../../common/forms/FormInput";
import ActionBtn from "../../../common/management/ActionBtn";

import { getDefaultImage } from "../../../utils/GeneralUtils";
import { ValType } from "../../../utils/ValidationFunctions";

import styles from "../db-list/DBList.module.scss";
import input_styles from "./AddSchool.module.scss";

type Props = {
  i: number;
  id: string;
  name?: string;
  img?: string;
  color?: string;
  noColor?: boolean;
  handleSubmit: (
    item_id: string,
    name?: string,
    color?: string,
    img?: File
  ) => void;
};

const TermListItem: React.FC<Props> = ({
  i,
  id,
  name,
  img,
  color,
  noColor,
  handleSubmit,
}) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [editName, setEditName] = useState<string>();
  const [editColor, setEditColor] = useState<string>();
  const [imgSrc, setImgSrc] = useState<File | undefined>(undefined);

  const onSubmit = () => {
    handleSubmit(id, editName, editColor, imgSrc);
    setIsEdit(false);
  };

  return (
    <>
      <Form handler={onSubmit}>
        <div
          className={
            isEdit === true
              ? img !== undefined
                ? `${styles["f-dbList__category"]} ${styles["body"]} ${styles["term"]} ${styles["edit"]}`
                : `${styles["f-dbList__category"]} ${styles["body"]} ${styles["courses"]} ${styles["edit"]}`
              : img !== undefined
              ? `${styles["f-dbList__category"]} ${styles["body"]} ${styles["term"]}`
              : `${styles["f-dbList__category"]} ${styles["body"]} ${styles["courses"]}`
          }
        >
          {name !== undefined ? (
            <div className={styles["name"]}>
              <FormInput
                handler={(value) => {
                  if (value !== undefined && typeof value === "string") {
                    setEditName(value);
                  }
                }}
                type="text"
                label=""
                name="term_name"
                style_class={
                  isEdit === true
                    ? input_styles["f-addSchool__form-input__text"]
                    : ""
                }
                initial_value={name}
                disabled={isEdit === true ? false : true}
              />
            </div>
          ) : null}
          {/* <div>{school.studentcount}</div> */}
          {img !== undefined ? (
            <div className={styles["img"]}>
              <img
                src={
                  imgSrc !== undefined
                    ? URL.createObjectURL(imgSrc)
                    : img !== ""
                    ? img
                    : getDefaultImage()
                }
                className={input_styles["f-addSchool__form-value__img"]}
              />
              <FormInput
                handler={(value) => {
                  if (value !== undefined && value instanceof File) {
                    setImgSrc(value);
                  }
                }}
                type="file"
                label="画像を変更"
                name="img_name"
                id={`school_img_${i}`}
                label_class={
                  isEdit === true
                    ? input_styles["f-addSchool__form-input__img-label"]
                    : styles["noedit"]
                }
                disabled={isEdit === true ? false : true}
                val_type={ValType.File}
              />
            </div>
          ) : null}
          {!noColor ? (
            <div className={styles["color"]}>
              <FormInput
                handler={(value) => {
                  if (value !== undefined && typeof value === "string") {
                    setEditColor(value);
                  }
                }}
                type="color"
                label=""
                name="color_name"
                style_class={
                  isEdit === true
                    ? input_styles["f-addSchool__form-input__color-style"]
                    : styles["noedit"]
                }
                initial_value={color ? color : "#000000"}
                disabled={isEdit === true ? false : true}
              />
              <span className={input_styles["f-addSchool__form-value__color"]}>
                {editColor ? editColor : color ? color : "#000000"}
              </span>
            </div>
          ) : null}
          {/* student count and admin */}
          <div>
            {isEdit ? (
              <ActionBtn
                label="保存"
                icon={["fal", "edit"]}
                onClick={onSubmit}
                colorReversal={true}
              />
            ) : (
              <ActionBtn
                label="編集"
                icon={["fal", "edit"]}
                onClick={() => setIsEdit(true)}
              />
            )}
          </div>
        </div>
      </Form>
    </>
  );
};

export default TermListItem;
